<template>
  <div>
    <div>
      <v-card style="position: relative">
        <v-card-title>
          Member Management

          <v-spacer></v-spacer>

          <v-text-field
            append-icon="search"
            label="Search"
            v-model="search"
            class="mr-2"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :items="members"
          :headers="headers"
          :footer-props="{ 'item-per-page-options': [15, 30, 50, 100] }"
          :search="search"
          class="clickable"
          mobile-breakpoint="0"
        >
          <template v-slot:item="{ item }">
            <tr :key="item.id">
              <td>{{ item.member_code }}</td>
              <td>{{ item.quota }}</td>
              <td>
                <v-switch
                  :input-value="item.is_active"
                  @change="activateMember(!item.is_active, item.id)"
                ></v-switch>
              </td>
              <td>
                <v-icon small color="primary" class="mr-2" @click="click(item)">mdi-open-in-new</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-if="showEditMember" v-model="showEditMember" persistent>
      <member-detail
        create
        @close="() => { closeCreateProduct(false) }"
      ></member-detail>
    </v-dialog>
  </div>
</template>

<script>
  import { findIndex } from 'lodash'

  export default {
    name: 'member-list',

    props: {
      memberComponent: String,
      memberService: Object,
    },

    data () {
      return {
        search: null,

        loading: false,

        members: [],

        headers: [
          { text: 'Member Code', value: 'member_code', align: 'left' },
          { text: 'Remaning Quota', value: 'quota', align: 'left' },
          { text: 'Is Active', value: 'is_active', align: 'left' },
        ],

        showEditMember: false,
      }
    },

    created () {
      this.updateTable()
      this.$store.commit('UPDATE_TITLE', 'My Member')
    },

    methods: {
      async updateTable () {
        this.loading = true

        try {
          const { data } = await this.memberService.getAll()
          this.members = data.data
        } catch (error) {
          console.log('fetch member data failed. Error: ', error)
        }

        this.loading = false
      },

      async activateMember (val, id) {
        const memberIndex = findIndex(this.members, (o) => {
          return o.id === id
        })

        this.members[memberIndex].is_active = val

        try {
          this.members[memberIndex].loading = true

          await this.memberService.update(id, { is_active: val })
        } catch (error) {
          console.log('update member data failed. Error: ', error)
        }

        this.members[memberIndex].loading = false
      },

      click (member) {
        this.$router.push({
          name: 'SlottingTransactionOverview',
          params: {
            external_member_id: member.id,
            external_member_code: member.member_code,
          },
        })
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .hidden
    display: none;
</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Member/MemberList.vue